
import {CART_ACTION_TYPES} from './cart.types'

export const INTIAL_STATE = {
    cartItems: [],
    isCartOpen: false,
}


export const cartReducer = (state = INTIAL_STATE, action = {}) =>{

    const {type, payload} = action;

    switch (type) {
        case CART_ACTION_TYPES.SET_CART_ITEM:
            return{
                ...state,
                cartItems: payload
            }
        case CART_ACTION_TYPES.SET_IS_CART_OPEN:
            return{
                ...state,
                isCartOpen:payload
            }    
        default:
           return state
    }
}